import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=295db302&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=295db302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295db302",
  null
  
)

export default component.exports